import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, articles } from '@/mocks/data';
import { useState, FormEvent } from 'react';

const featuredArticles = [
  'si-ren-zhi-jian-de-tiao-pi-shi',
  'ming-ren-zhuan-cheng-fa',
  'congming-yixiu-chengfa',
  'longzhu-jingdian-chengfa',
];

export default function Home() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subMsg, setSubMsg] = useState('');

  const hotArticles = [...articles].sort((a, b) => b.readCount - a.readCount).slice(0, 6);
  const recentArticles = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 4);
  const featured = articles.filter((a) => featuredArticles.includes(a.slug));

  const handleSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubStatus('success');
      setSubMsg('订阅成功！感谢您的关注～');
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9qa9ksnlsngrm4llug0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setSubMsg('订阅成功！感谢您的关注～');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        setSubStatus('error');
        setSubMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setSubStatus('error');
      setSubMsg('网络错误，请稍后重试');
    }
  };

  const siteUrl = 'https://dapigumanhua.com';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '打屁股漫画大全',
        url: siteUrl,
        description: '最全面的惩罚教育漫画场景合集，收录搞笑亲子、校园故事、经典漫画等丰富内容',
      },
      {
        '@type': 'WebSite',
        name: '打屁股漫画大全',
        url: siteUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '打屁股漫画大全 - 首页',
        description: '探索打屁股漫画的精彩世界，收录各类经典惩罚教育场景漫画，涵盖搞笑、亲子教育、校园故事等多种风格',
        url: siteUrl,
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="打屁股漫画大全 · 经典惩罚场景合集 - 最全惩罚教育漫画平台"
        description="探索打屁股漫画的精彩世界，收录各类经典惩罚教育场景漫画，涵盖搞笑、亲子教育、校园故事等多种风格。喜欢打屁股漫画的读者可在此找到最全合集，感受漫画艺术中的幽默与温情教育元素。"
        keywords="打屁股漫画,打屁股漫画合集,惩罚教育漫画,搞笑亲子漫画,校园惩罚漫画,经典漫画场景,幽默教育漫画"
        canonicalUrl={siteUrl}
      />
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20manga-inspired%20illustration%20featuring%20multiple%20comic%20panels%20and%20characters%20in%20soft%20watercolor%20style%2C%20warm%20cream%20and%20soft%20orange%20tones%2C%20Japanese-style%20comic%20layout%20with%20speed%20lines%20and%20action%20elements%2C%20gentle%20and%20playful%20atmosphere%2C%20light%20paper%20texture%20background%2C%20minimalist%20composition%20with%20ample%20open%20space%20for%20text&width=1800&height=900&seq=hero-home-2026&orientation=landscape"
            alt="打屁股漫画大全 - 英雄区域背景图"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
          <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              打屁股漫画大全
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed">
              探索惩罚教育漫画的精彩世界，收录搞笑亲子、校园故事、经典场景等丰富漫画内容，在欢笑中感受漫画艺术的幽默与温情
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/gaoxiao-qinzi"
                className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始探索
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer border border-white/30"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              漫画分类
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-900 mb-2">{cat.name}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-16 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                精选推荐
              </h2>
              <Link
                to="/category/jingdian-changjing"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
              {featured.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full mb-2">
                      {categories.find((c) => c.slug === article.category)?.name}
                    </span>
                    <h3 className="font-heading font-bold text-foreground-900 text-sm mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2">{article.excerpt}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Articles */}
        <section className="py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              热门文章
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {hotArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="flex gap-4 p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="w-24 h-24 flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full mb-1">
                      {categories.find((c) => c.slug === article.category)?.name}
                    </span>
                    <h3 className="font-heading font-bold text-foreground-900 text-sm mb-1 line-clamp-2 hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span><i className="ri-eye-line mr-1"></i>{(article.readCount / 1000).toFixed(1)}k</span>
                      <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Recent Articles */}
        <section className="py-16 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
              最新发布
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {recentArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="flex flex-col sm:flex-row gap-4 p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-2">
                      <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full">
                        {categories.find((c) => c.slug === article.category)?.name}
                      </span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="font-heading font-bold text-foreground-900 mb-1 hover:text-primary-600 transition-colors line-clamp-1">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
                    <div className="flex items-center gap-4 mt-2 text-xs text-foreground-500">
                      <span>{article.author}</span>
                      <span><i className="ri-eye-line mr-1"></i>{(article.readCount / 1000).toFixed(1)}k 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="py-16 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-6">
                <i className="ri-mail-send-line text-2xl"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                订阅我们的漫画更新
              </h2>
              <p className="text-foreground-600 mb-8">
                第一时间获取最新漫画场景分析和精彩内容推荐，每周为你推送精选文章
              </p>
              <form
                onSubmit={handleSubscribe}
                data-readdy-form
                className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute left-[-9999px] opacity-0 h-0 w-0 overflow-hidden pointer-events-none"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入你的邮箱地址"
                  required
                  className="flex-1 px-4 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  立即订阅
                </button>
              </form>
              {subStatus !== 'idle' && (
                <p className={`mt-4 text-sm ${subStatus === 'success' ? 'text-accent-600' : 'text-red-500'}`}>
                  {subMsg}
                </p>
              )}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}